import { TutorsLoader } from './parts/TutorsLoader';
import StudentTabsHeader from '../StudentTabsHeader';
import { useParams } from 'react-router-dom';
import { isNumber } from '../../../../utils/math';
import { useMemo } from 'react';
import { TutorsTable } from './parts/TutorsTable';
import { Row, Col } from 'reactstrap';
import { SectionTitle } from '../../../../components/text';
import { useTexts } from './hooks/useTexts';

export function StudentTutors() {
  const texts = useTexts();
  const { studentId } = useParams<{ studentId: string }>();
  const studentIdInt = useMemo(() => {
    if (isNumber(studentId)) {
      return Number(studentId);
    }
    return null;
  }, [studentId]);
  if (!studentIdInt) {
    throw new Error('Invalid postulantId');
  }

  return (
    <TutorsLoader studentId={studentIdInt}>
      {({ data, refresh }) => (
        <>
          <StudentTabsHeader
            id={data.studentPlansAndTutors.student.rut}
            name={data.studentPlansAndTutors.student.fullName}
          />
          <Col className="my-4">
            <Row>
              <SectionTitle text={texts.sectionTitle} />
            </Row>
          </Col>
          <TutorsTable tutorsData={data} refresh={refresh} />
        </>
      )}
    </TutorsLoader>
  );
}
